import styled, {css} from 'styled-components';

const paddingStyle = css`
  max-width: 50rem;

  @media (max-width: 1024px) {
    padding: 0 40px;
  }
`;

export const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 0;
  //
  //@media (min-width: 1600px) {
  //  max-width: 1440px;
  //}
  ${({padding}) => padding && paddingStyle}
`;
